module.exports = "/static/assets/0f83313fc24139957bd5756a6734b491.png";